export default __webpack_public_path__ + "static/media/k10.7eb88867.jpg";